// extracted by mini-css-extract-plugin
export const wrapper = "footer-module--wrapper--3oIQ3";
export const footerMargin = "footer-module--footerMargin--rJcPq";
export const socialWrapper = "footer-module--socialWrapper--JprQd";
export const ctaWrapper = "footer-module--ctaWrapper--1I2Va";
export const ctaButton = "footer-module--ctaButton--2LHpg";
export const cpWrapper = "footer-module--cpWrapper--1H83R";
export const buttonsWrapper = "footer-module--buttonsWrapper--1vl4B";
export const emailInput = "footer-module--emailInput--3tynM";
export const text = "footer-module--text--2fmyp";